import { Section } from '../template.state.types';

export type SectionNames = 'topSection' | 'cardsSection' | 'contentSection1' | 'contentSection2' | 'contentSection3';

export interface HomePageState {
    topSection: Section,
    cardsSection: Section,
    contentSection1: Section,
    contentSection2: Section,
    contentSection3: Section,
}

export type HomePageAction = {type: string};

export const homePageReducer = (state:HomePageState = {} as HomePageState, action:HomePageAction) => {
  switch (action.type) {
    default:
      return state;
  }
};
